import { render, staticRenderFns } from "./FokusIframe.vue?vue&type=template&id=1aed5995&"
import script from "./FokusIframe.vue?vue&type=script&lang=js&"
export * from "./FokusIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports